import React, { useEffect, useRef, useState } from "react";
import Licenses from "components/font-licensing/licenses";

type Props = {
  routes: { cart: string };
  orderLicenseTypes: string[];
  licenseText: { desktop: string; web: string; app: string };
};

const CheckoutLicenseAgreement: React.FC<Props> = (props) => {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const [selectedLicenseType, setSelectedLicenseType] = useState(props.orderLicenseTypes[0]);
  const [acceptedLicenses, setAcceptedLicenses] = useState(
    props.orderLicenseTypes.reduce((acc, type) => {
      acc[type] = false;
      return acc;
    }, {} as Record<string, boolean>)
  );
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
      setScrolledToBottom(atBottom);
    };

    el.addEventListener("scroll", handleScroll, { passive: true });
    if (el.scrollHeight <= el.clientHeight) setScrolledToBottom(true);
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinceseTypeChange = (type: string) => {
    setSelectedLicenseType(type);
    scrollRef.current?.scrollTo(0, 0);
  }

  const handleDisagree = () => {
    if (scrolledToBottom) window.location.href = props.routes.cart;
  };

  const handleSubmit = (event: React.FormEvent) => {
    if (!scrolledToBottom) return;

    const currentAcceptedLicenses = {
      ...acceptedLicenses,
      [selectedLicenseType]: true
    };
    setAcceptedLicenses(currentAcceptedLicenses);

    // Find the next license type that hasn't been accepted yet, if none this
    // will return undefined and we can proceed with the form submission.
    // Otherwise, we'll move to the next license type.
    const nextType = Object.keys(currentAcceptedLicenses).find((type) => !currentAcceptedLicenses[type]);
    if (nextType) {
      event.preventDefault();
      setSelectedLicenseType(nextType);
    }
  };

  const submitButtonText = () => {
    const acceptedType = acceptedLicenses[selectedLicenseType];
    return acceptedType ? "Accepted License" : "I Agree to the Terms";
  }

  return (
    <div className="license-screen">
      <h1 className="license-title">Font Licenses</h1>

      <div className="license-box-wrapper">
        <Licenses
          handleTypeChange={handleLinceseTypeChange}
          licenseText={props.licenseText}
          scrollRef={scrollRef}
          selectedLicenseType={selectedLicenseType}
          visibleLicenseTypes={props.orderLicenseTypes}
        >
        <form action="/checkout/update/license" method="POST" onSubmit={handleSubmit}>
          <input type="hidden" name="_method" value="patch" />
          <input
            type="hidden"
            name="authenticity_token"
            value={document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''}
          />
          <input type="hidden" name="order[agreed_to_license]" value="true" />
          <input
            type="hidden"
            name="order[license_agreement_completed_at]"
            value={new Date().toISOString()}
          />
          <div className="license-agreement-actions">
            <button
              type="button"
              className="license-button disagree"
              disabled={!scrolledToBottom && acceptedLicenses[selectedLicenseType] === false}
              onClick={handleDisagree}
            >
              I Do Not Agree
            </button>
            <button
              type="submit"
              className="license-button agree"
              disabled={!scrolledToBottom || acceptedLicenses[selectedLicenseType] === true}
            >
              {submitButtonText()}
            </button>
          </div>
        </form>
        </Licenses>
      </div>
    </div>
  );
};

export default CheckoutLicenseAgreement;

